import { render, staticRenderFns } from "./Curso.vue?vue&type=template&id=3cd391db&"
import script from "./Curso.vue?vue&type=script&lang=js&"
export * from "./Curso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports